
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12728',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12728",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9774",
  "foundations-components": "static-1.8150",
  "foundations-components-legacy": "static-1.1175",
  "foundations-theming": "static-1.4543",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8133",
  "hub-http-shared-msw-handlers": "static-1.10241",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11588",
  "I18n": "static-7.1637",
  "jasmine-runner": "static-1.6570",
  "marketplace-storefront-base": "static-1.12791",
  "quartz": "static-1.7171",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16796",
  "reactive-variable-buffer-atom": "static-1.2970",
  "reporting-testing-lib": "static-1.9960",
  "settings-ui-lib": "static-1.12632",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7340",
  "ui-addon-i18n": "static-1.11261",
  "ui-addon-react-router-dom": "static-1.9649",
  "unified-auth": "static-1.626",
  "unified-auth-core-lib": "static-1.908",
  "usage-tracker": "static-1.7461",
  "usage-tracker-core": "static-1.7311",
  "customer-data-property-utils": "static-1.8208",
  "hub-http": "static-1.6335",
  "integrations-lib": "static-1.16513",
  "marketplace-ui-common": "static-1.20146",
  "property-management-iframe": "static-1.13543",
  "quartz-config": "static-1.949",
  "quartz-core": "static-1.6390",
  "quartz-routing": "static-1.601",
  "quick-fetch": "static-1.3999",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4769",
  "ts-schema": "static-1.4162",
  "ui-universal-auth": "static-1.9112",
  "UIComponents": "static-3.8534",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3479",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3448",
  "quartz-webpack": "static-1.3395",
  "bend-plugin-quartz-routing": "static-1.249",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4419",
  "floating-ui": "static-1.58",
  "foundations-assets": "static-1.4985",
  "foundations-theming-specialty": "static-1.2259",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9534",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.35",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5424",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2189",
  "ui-fonts": "static-1.850",
  "ui-images": "static-2.1180",
  "bend-plugin-foundations-theming": "static-1.3026",
  "foundations-theming-base": "static-1.3528",
  "stylex": "static-1.35",
  "HeadJS": "static-2.768",
  "hs-test-utils-bend-plugin": "static-1.3244",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4437",
  "ai-components-ui-library": "static-1.9240",
  "ai-rendering-library": "static-1.10581",
  "chirp-fetch": "static-1.1999",
  "connections-embed-lib": "static-1.1202",
  "copilot-toolkit": "static-1.11427",
  "feedback-loader": "static-1.29507",
  "laboratory-lib": "static-3.7265",
  "marketplace-embed": "static-1.22444",
  "marketplace-ui-details": "static-1.10041",
  "marketplace-ui-reviews": "static-1.20101",
  "marketplace-ui-tracking": "static-1.14316",
  "sanitize-text": "static-1.8257",
  "ui-addon-video-player": "static-1.8815",
  "usage-tracker-multi": "static-1.5875",
  "usage-tracker-session-replay": "static-1.5147",
  "wootric-nps": "static-1.7065",
  "quartz-head": "static-1.836",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4763",
  "immer": "static-1.33",
  "immerable": "static-1.4262",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2568",
  "reporting-data": "static-1.68027",
  "cssUtils": "static-1.824",
  "flux-actions": "static-1.345",
  "HubStyle": "static-2.11895",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10319",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10475",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7451",
  "icons": "static-2.653",
  "marketplace-ui-apps-core": "static-1.18678",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4624",
  "foundations-components-test-utils": "static-1.5633",
  "quartz-i18n": "static-1.846",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.7",
  "ads-unified-auth-lib": "static-1.363",
  "google-sheets-integration-lib": "static-1.570",
  "microsoft-drive-integration-lib": "static-1.701",
  "surveymonkey-integration-lib": "static-1.27",
  "slack-ui-library": "static-1.10506",
  "fsm": "static-1.3840",
  "customer-data-objects": "static-1.7791",
  "property-translator": "static-1.5508",
  "hs-locale-management": "static-1.163",
  "frontend-preferences-client": "static-1.8039",
  "hs-promise-utils": "static-1.5703",
  "hubspot-apollo-client": "static-1.4990",
  "integrations-error-boundary-lib": "static-1.13928",
  "integrations-tracking-lib": "static-1.5718",
  "native-integrations-shared-strings": "static-1.7895",
  "reselect": "static-2.16",
  "sanitize": "static-1.4587",
  "superstore": "static-1.4871",
  "ui-shepherd-react": "static-3.10350",
  "ai-settings-ui-library": "static-1.8064",
  "hub-http-janus": "static-1.845",
  "hubspotter-http": "static-1.4732",
  "immutable-less": "static-1.4765",
  "marketplace-ui-client-types": "static-1.17553",
  "nav-meta": "static-1.29925",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18147",
  "inbound-db-properties-service-client": "static-1.3927",
  "property-management-common": "static-1.5831",
  "ui-addon-iframeable": "static-1.9179",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.544",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.846",
  "quartz-test": "static-1.846",
  "quartz-tracking": "static-1.550",
  "trellis-components": "static-1.2208",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.179",
  "bender-build-tools": "static-1.3281",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21831",
  "ContentUtils": "static-1.68687",
  "customer-data-objects-ui-components": "static-1.13142",
  "sassPrefix": "static-1.158",
  "avatar-components": "static-1.2609",
  "breeze-engine-core": "static-1.389",
  "breeze-onboarding-components": "static-1.244",
  "customer-data-filters-ui": "static-1.40189",
  "customer-data-reference-ui-components": "static-1.13285",
  "embedded-academy-lib": "static-1.14732",
  "ExportDialog": "static-6.10492",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41589",
  "reporting-snowflake": "static-1.56645",
  "reporting-ui-components": "static-2.65298",
  "reporting-visualizations": "static-1.60103",
  "trellis-theming": "static-1.1054",
  "ui-addon-teams": "static-1.21695",
  "integrations-reconnect-lib": "static-1.175",
  "magpie-lib": "static-1.5625",
  "navigation-components": "static-1.18288",
  "breeze-engine-lib": "static-1.1111",
  "magpie-types": "static-1.5085",
  "simple-logging-lib": "static-1.3161",
  "ai-studio-lib": "static-1.11945",
  "app-governance-lib": "static-1.1911",
  "developer-experience-shared-components": "static-1.10626",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8120",
  "ui-product-approvals": "static-1.28602",
  "ui-tool-access": "static-1.10260",
  "usage-based-billing-components-lib": "static-1.9409",
  "usage-tracker-anonymous": "static-1.5878",
  "usage-tracker-public": "static-1.7272",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3668",
  "persist-promise": "static-1.3812",
  "reference-resolvers": "static-1.8287",
  "ui-extensibility-client-types": "static-1.4036",
  "hubspot-apollo-cache": "static-1.449",
  "universal-page-editor-lib": "static-1.3130",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3094",
  "atom": "static-1.5187",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6085",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1655",
  "crm-component-utils": "static-1.39377",
  "crm-properties-common-lib": "static-1.6000",
  "customer-data-properties": "static-1.51967",
  "framework-data-schema-resolvers": "static-1.7004",
  "property-value-citations": "static-1.2581",
  "reference-resolvers-lite": "static-1.8210",
  "ui-business-units-lib": "static-1.9179",
  "navigation-messaging": "static-1.7615",
  "hubspotter-http-shared-msw-handlers": "static-1.10239",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4927",
  "content-icons-ui": "static-1.2257",
  "customer-data-ui-utilities": "static-1.9938",
  "conversations-skeleton-state": "static-1.7360",
  "crm-message-bus": "static-1.43277",
  "customer-data-filters-ui-msw-helpers": "static-1.22624",
  "events-data-lib": "static-1.343",
  "FormUrlGenerator": "static-2.4833",
  "framework-builder-read-service-client": "static-1.4086",
  "framework-data-schema-quick-fetch": "static-1.6909",
  "multi-account-reference-resolvers": "static-1.1094",
  "onboarding-tours": "static-1.16812",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14004",
  "academy-common-lib": "static-1.14192",
  "content-assistance-lib": "static-1.7930",
  "dashboard-lib": "static-1.81970",
  "file-manager-components": "static-1.23934",
  "getting-started-shared-tasks": "static-1.18726",
  "hubspot-prosemirror": "static-1.18560",
  "hubspot-prosemirror-plugins": "static-1.18552",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20025",
  "share-with-third-party-component-lib": "static-1.8817",
  "ui-addon-draggable": "static-3.4871",
  "ui-asset-management-lib": "static-1.11176",
  "user-context": "static-1.5222",
  "growth-payments-core": "static-1.25711",
  "reporting-plugins": "static-1.10502",
  "reporting-reports": "static-1.67705",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.837",
  "nest": "static-1.344",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10739",
  "framework-listing-lib": "static-2.29010",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30976",
  "apps-service-types": "static-1.3911",
  "oauth-service-types": "static-1.4366",
  "react-dnd-compat": "static-1.4727",
  "ui-product-approvals-common": "static-1.497",
  "onboarding-scopes": "static-1.6573",
  "onboarding-tours-client": "static-1.5026",
  "platform-infra-nav-components": "static-1.7753",
  "subscription-experience-data-types": "static-1.15063",
  "crm-record-cards-service-types": "static-1.3671",
  "location-customization-utils-lib": "static-1.9592",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6088",
  "signup-constants": "static-1.19112",
  "signup-ui-url-generator": "static-2.8170",
  "card-properties-lib": "static-1.44533",
  "commerce-subscription-lib": "static-1.37402",
  "crm-actions": "static-1.6452",
  "crm-cards-sdk": "static-1.43923",
  "customer-data-properties-shared-msw-handlers": "static-1.9568",
  "customer-data-tracking": "static-1.7000",
  "hs-resources": "static-1.284",
  "pulse": "static-1.710",
  "calling-global-api": "static-1.64900",
  "calling-internal-common": "static-1.31422",
  "calling-lifecycle-internal": "static-1.66282",
  "calling-lifecycle-messages": "static-1.58576",
  "commerce-products-lib": "static-1.9966",
  "conditional-properties-service-client": "static-1.3877",
  "crm-links": "static-1.6420",
  "crm-pipelines-api-client-types": "static-1.4219",
  "external-options-client-types": "static-1.4209",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4298",
  "meetings-icalendar-utils-lib": "static-1.746",
  "multi-currency-client-types": "static-1.3772",
  "object-builder-ui-client": "static-1.49134",
  "pipeline-validation-client-types": "static-1.4048",
  "smart-property-lib": "static-1.7789",
  "tiered-pricing": "static-1.1509",
  "ui-addon-form-validation": "static-1.11101",
  "zustand": "static-1.74",
  "fdsr-migration-layer": "static-1.123",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1161",
  "growth-data-modal": "static-1.5606",
  "growth-onboarding-confetti": "static-1.3177",
  "growth-onboarding-next-action-utils": "static-1.2242",
  "onboarding-tours-utils": "static-1.878",
  "ui-shepherd-tracker": "static-1.7731",
  "academy-service-client": "static-1.3795",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39433",
  "FileManagerLib": "static-1.39574",
  "SafeStorage": "static-1.4511",
  "video-embed": "static-1.36133",
  "ui-coaching-tips": "static-1.28874",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11641",
  "video-data-lib": "static-1.35299",
  "content-media-capture": "static-1.4855",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23821",
  "ui-addon-emoji-picker": "static-1.9998",
  "EmailSignatureEditor": "static-1.24622",
  "viral-links-lib": "static-1.7181",
  "data-token-picker": "static-1.16604",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.336",
  "timezone-utils": "static-2.5355",
  "seat-types-lib": "static-1.270",
  "getting-started-shared-tasks-store": "static-1.17844",
  "ui-addon-opt": "static-4.8473",
  "campaign-roi-lib": "static-1.9432",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25668",
  "framework-data-table": "static-2.12173",
  "marketing-platform-lib": "static-1.6977",
  "nudge-client-utils": "static-1.2815",
  "nudge-custom-ui-functions": "static-1.1223",
  "switchboard-lib": "static-1.335",
  "app-users-service-client": "static-1.5720",
  "app-users-service-types": "static-1.5128",
  "mini-checkout-client": "static-1.27087",
  "onboarding-utils": "static-1.5471",
  "permissions-shared-i18n-strings-fe": "static-1.2061",
  "ui-coaching-tips-shared-config": "static-1.28859",
  "edison-service-client-types": "static-1.501",
  "crm_data": "static-4.92323",
  "customer-data-sidebar": "static-2.46326",
  "enrichment-properties-lib": "static-1.16907",
  "ui-addon-draggable-compat": "static-2.4371",
  "universal-record-utils-lib": "static-1.1240",
  "commerce-billing-lib": "static-1.19454",
  "commerce-shared-components-lib": "static-1.18809",
  "commerce-tools-ui-lib": "static-1.10676",
  "crm-fe-perf": "static-1.23015",
  "event-emitter": "static-1.1061",
  "bend-plugin-pulse": "static-1.213",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31429",
  "shared-worker-versioning": "static-1.11148",
  "calling-usage-tracker": "static-1.6655",
  "voice-sms-access-library": "static-1.1431",
  "commerce-permissions": "static-1.888",
  "products-iframe-lib": "static-1.8242",
  "products-ui-components-shared-msw-handlers": "static-1.10623",
  "data-agent-kit": "static-1.379",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10324",
  "policy-lib": "static-1.6893",
  "react-tinymce": "static-1.55539",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10387",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54665",
  "tinymce-plugins": "static-1.57779",
  "tinymce-themes": "static-1.56635",
  "onboarding-data-sync-lib": "static-1.2153",
  "growth-onboarding-next-action-components": "static-1.2270",
  "user-context-client": "static-1.4692",
  "audio-components": "static-1.6088",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37085",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4648",
  "video-components": "static-1.13643",
  "outpost": "static-1.4282",
  "growth-onboarding-feedback-components": "static-1.6691",
  "content-media-composition-data-lib": "static-1.12659",
  "content-media-compositions": "static-2.16666",
  "media-bridge-lib": "static-1.19120",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4536",
  "commerce-tours-lib": "static-1.6304",
  "growth-onboarding-reliability": "static-1.5193",
  "sales-checkout-service-client": "static-1.3705",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21872",
  "sales-email-signature-service-client": "static-1.3962",
  "ts-utils-lib": "static-1.285",
  "crm-export-dialog": "static-1.6397",
  "crm-index-associations-lib": "static-1.6553",
  "crm-view-components": "static-1.616",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7442",
  "nudge-custom-function-registry": "static-1.2572",
  "nudge-renderer-utils": "static-1.2891",
  "whisper-core-api": "static-1.6872",
  "InboxConnectUtils": "static-4.15107",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5798",
  "settings-content-modals": "static-1.46400",
  "crm_universal": "static-1.22206",
  "customer-data-email": "static-1.18234",
  "card-payment-highlight-lib": "static-1.37499",
  "card-subscription-highlight-lib": "static-1.39825",
  "commerce-contract-lib": "static-1.12606",
  "invoices-highlight-card-lib": "static-1.55094",
  "orders-highlight-card-lib": "static-1.21774",
  "products-highlight-card-lib": "static-1.18249",
  "quotes-highlight-card-lib": "static-1.72382",
  "crm-source-interpretation-lib": "static-1.5456",
  "crm-object-search-query-utilities": "static-1.9836",
  "utility-belt": "static-1.2644",
  "payments-enrollment-embed-lib": "static-1.23244",
  "stripe-embedded-components": "static-1.7707",
  "customer-data-rte": "static-1.33292",
  "cv-backend-services": "static-1.1558",
  "growth-onboarding-empty-states": "static-1.5947",
  "payments-post-enroll-local-storage-lib": "static-1.5218",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38472",
  "trials-service-types": "static-1.3994",
  "calling-orchestration-schema": "static-1.36208",
  "sales-views-client-types": "static-1.4369",
  "hub-http-contrib": "static-1.3156",
  "interframe": "static-3.4872",
  "tinymce-data": "static-1.40750",
  "ui-addon-sales-email": "static-1.5321",
  "layout-dnd-components": "static-1.12662",
  "layout-dnd-utils": "static-1.11637",
  "ui-brand-identity-lib": "static-1.15687",
  "NamespacedHubStyle": "static-2.9136",
  "meetings-connect-utils-lib": "static-1.7717",
  "social-insights-client-types": "static-1.22327",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4282",
  "checkout-sdk": "static-3.23930",
  "company-details-components": "static-1.6310",
  "payment-method-components": "static-1.6983",
  "pricing-pages-ui-components": "static-1.14691",
  "quote-checkout-service-types": "static-1.3577",
  "upgrade-catalog-service-types": "static-1.3634",
  "access-control-lib": "static-1.10548",
  "EmailComponents": "static-1.55080",
  "EmailData": "static-1.53757",
  "redux-less": "static-2.9595",
  "sequences-lib": "static-1.8244",
  "ui-gdpr-components": "static-1.10462",
  "products-ui-components": "static-1.40484",
  "accounting-integrations-ui-components": "static-1.7247",
  "invoices-ui-lib": "static-1.55110",
  "commerce-products-api": "static-1.2461",
  "invoices-iframe-lib": "static-1.57168",
  "quotes-modal-lib": "static-1.103060",
  "quotes-ui-lib": "static-1.81103",
  "stripe-connect-js": "static-1.71",
  "draft-content-plugins": "static-1.28559",
  "ContentData": "static-1.68762",
  "layout-data-lib": "static-1.9962",
  "checkout-service-types": "static-1.3879",
  "hub-http-rxjs": "static-1.809",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4049",
  "billing-payments-client-types": "static-1.4102",
  "react-performance-metrics-lib": "static-1.669",
  "account-and-billing-fintech-outages": "static-3.18717",
  "pricing-pages-api": "static-1.14556",
  "ContentComponents": "static-2.71643",
  "marketing-contacts-lib": "static-1.10420",
  "marketing-email-service-types": "static-1.1983",
  "messaging-editing-lib": "static-1.46589",
  "messaging-usage-based-billing-components-lib": "static-1.1451",
  "automation-ui-source-apps": "static-1.19211",
  "automation-ui-types": "static-1.20129",
  "messaging-types-lib": "static-1.46326",
  "onboarding-settings-client": "static-1.4615",
  "sequences-client-types-lib": "static-1.8101",
  "commerce-tax-lib": "static-1.648",
  "price-books-api": "static-1.1233",
  "price-books-components": "static-1.1291",
  "property-description-translator": "static-1.3952",
  "ramp-editor": "static-1.443",
  "commerce-analytics-service-client": "static-1.3693",
  "totals-ui-components": "static-1.23904",
  "SalesContentIndexUI": "static-3.9403",
  "advanced-menus-core": "static-1.15312",
  "advanced-menus-lib": "static-1.12225",
  "ui-memberships-settings-lib": "static-1.34343",
  "segments-query-core": "static-1.1532",
  "automation-ui-ubb": "static-1.6045",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7451",
  "data-token-views": "static-1.16585",
  "forms-utils-lib": "static-1.12792",
  "payments-embed-points-lib": "static-1.13262",
  "simple-menus-core": "static-1.15311",
  "simple-menus-lib": "static-1.16828",
  "videoconference-integration-components": "static-1.6981",
  "marketing-contacts-client": "static-1.7624",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2632",
  "ContentEditorUI": "static-2.77423",
  "short-messages-app-service-client": "static-1.4035",
  "web-interactives-components": "static-1.13957",
  "web-interactives-data": "static-1.13958",
  "messaging-shared-utils-lib": "static-1.900",
  "messaging-user-info-utils-lib": "static-1.1070",
  "email-portal-health-service-types": "static-1.1088",
  "line-items-api": "static-1.857",
  "commerce-totals-service-types": "static-1.3899",
  "FireAlarmUi": "static-1.4589",
  "sales-templates-service-types-lib": "static-1.4250",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22065",
  "automation-ui-usage-tracking": "static-1.21528",
  "data-studio-ubb": "static-1.3048",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27276",
  "collaboration-sidebar": "static-1.58175",
  "content-management-data-lib": "static-1.5600",
  "copilot-plugins": "static-1.11400",
  "cta-picker": "static-1.36696",
  "customer-agent-discovery-components-lib": "static-1.3403",
  "editor-components": "static-1.13391",
  "editor-iframe-lib": "static-1.8557",
  "error-messaging-js": "static-1.5305",
  "FormsCommonComponents": "static-1.86118",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10759",
  "SharedLegalStrings": "static-1.1857",
  "smart-content-core": "static-1.42747",
  "smart-content-lib": "static-1.43400",
  "social-composer-lib": "static-1.59561",
  "structured-content-lib": "static-1.25491",
  "theme-previewer-lib": "static-1.53550",
  "tinymce-copilot": "static-1.16733",
  "xray-recommendation-lib": "static-1.8051",
  "automation-ui-routing": "static-1.21486",
  "sql-reporting-client-types": "static-1.5727",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42440",
  "campaigns-utils-lib": "static-1.3303",
  "reporting-enablement": "static-1.23312",
  "chatspot-widget-iframe": "static-1.21822",
  "collaboration-sidebar-common": "static-1.2972",
  "forms-ai-lib": "static-1.4493",
  "codemirror-dlb": "static-1.58982",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6547",
  "report-customization-components": "static-1.13478",
  "data-quality-ui-library": "static-1.13326",
  "reporting-filters": "static-1.601",
  "reporting-insights-lib": "static-1.2076"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12728",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9774",
  "foundations-components": "/foundations-components/static-1.8150",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1175",
  "foundations-theming": "/foundations-theming/static-1.4543",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8133",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10241",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11588",
  "I18n": "/I18n/static-7.1637",
  "jasmine-runner": "/jasmine-runner/static-1.6570",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12791",
  "quartz": "/quartz/static-1.7171",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16796",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2970",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9960",
  "settings-ui-lib": "/settings-ui-lib/static-1.12632",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7340",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11261",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9649",
  "unified-auth": "/unified-auth/static-1.626",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.908",
  "usage-tracker": "/usage-tracker/static-1.7461",
  "usage-tracker-core": "/usage-tracker-core/static-1.7311",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8208",
  "hub-http": "/hub-http/static-1.6335",
  "integrations-lib": "/integrations-lib/static-1.16513",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20146",
  "property-management-iframe": "/property-management-iframe/static-1.13543",
  "quartz-config": "/quartz-config/static-1.949",
  "quartz-core": "/quartz-core/static-1.6390",
  "quartz-routing": "/quartz-routing/static-1.601",
  "quick-fetch": "/quick-fetch/static-1.3999",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4769",
  "ts-schema": "/ts-schema/static-1.4162",
  "ui-universal-auth": "/ui-universal-auth/static-1.9112",
  "UIComponents": "/UIComponents/static-3.8534",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3479",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3448",
  "quartz-webpack": "/quartz-webpack/static-1.3395",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.249",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4419",
  "floating-ui": "/floating-ui/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4985",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2259",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9534",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.35",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5424",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2189",
  "ui-fonts": "/ui-fonts/static-1.850",
  "ui-images": "/ui-images/static-2.1180",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3026",
  "foundations-theming-base": "/foundations-theming-base/static-1.3528",
  "stylex": "/stylex/static-1.35",
  "HeadJS": "/HeadJS/static-2.768",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3244",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4437",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9240",
  "ai-rendering-library": "/ai-rendering-library/static-1.10581",
  "chirp-fetch": "/chirp-fetch/static-1.1999",
  "connections-embed-lib": "/connections-embed-lib/static-1.1202",
  "copilot-toolkit": "/copilot-toolkit/static-1.11427",
  "feedback-loader": "/feedback-loader/static-1.29507",
  "laboratory-lib": "/laboratory-lib/static-3.7265",
  "marketplace-embed": "/marketplace-embed/static-1.22444",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10041",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20101",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14316",
  "sanitize-text": "/sanitize-text/static-1.8257",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8815",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5875",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5147",
  "wootric-nps": "/wootric-nps/static-1.7065",
  "quartz-head": "/quartz-head/static-1.836",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4763",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4262",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2568",
  "reporting-data": "/reporting-data/static-1.68027",
  "cssUtils": "/cssUtils/static-1.824",
  "flux-actions": "/flux-actions/static-1.345",
  "HubStyle": "/HubStyle/static-2.11895",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10319",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10475",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7451",
  "icons": "/icons/static-2.653",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18678",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4624",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5633",
  "quartz-i18n": "/quartz-i18n/static-1.846",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.7",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.363",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.570",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.701",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.27",
  "slack-ui-library": "/slack-ui-library/static-1.10506",
  "fsm": "/fsm/static-1.3840",
  "customer-data-objects": "/customer-data-objects/static-1.7791",
  "property-translator": "/property-translator/static-1.5508",
  "hs-locale-management": "/hs-locale-management/static-1.163",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8039",
  "hs-promise-utils": "/hs-promise-utils/static-1.5703",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4990",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13928",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5718",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7895",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4587",
  "superstore": "/superstore/static-1.4871",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10350",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8064",
  "hub-http-janus": "/hub-http-janus/static-1.845",
  "hubspotter-http": "/hubspotter-http/static-1.4732",
  "immutable-less": "/immutable-less/static-1.4765",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17553",
  "nav-meta": "/nav-meta/static-1.29925",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18147",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3927",
  "property-management-common": "/property-management-common/static-1.5831",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9179",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.544",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.846",
  "quartz-test": "/quartz-test/static-1.846",
  "quartz-tracking": "/quartz-tracking/static-1.550",
  "trellis-components": "/trellis-components/static-1.2208",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.179",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21831",
  "ContentUtils": "/ContentUtils/static-1.68687",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13142",
  "sassPrefix": "/sassPrefix/static-1.158",
  "avatar-components": "/avatar-components/static-1.2609",
  "breeze-engine-core": "/breeze-engine-core/static-1.389",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.244",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40189",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13285",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14732",
  "ExportDialog": "/ExportDialog/static-6.10492",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41589",
  "reporting-snowflake": "/reporting-snowflake/static-1.56645",
  "reporting-ui-components": "/reporting-ui-components/static-2.65298",
  "reporting-visualizations": "/reporting-visualizations/static-1.60103",
  "trellis-theming": "/trellis-theming/static-1.1054",
  "ui-addon-teams": "/ui-addon-teams/static-1.21695",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.175",
  "magpie-lib": "/magpie-lib/static-1.5625",
  "navigation-components": "/navigation-components/static-1.18288",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1111",
  "magpie-types": "/magpie-types/static-1.5085",
  "simple-logging-lib": "/simple-logging-lib/static-1.3161",
  "ai-studio-lib": "/ai-studio-lib/static-1.11945",
  "app-governance-lib": "/app-governance-lib/static-1.1911",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10626",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8120",
  "ui-product-approvals": "/ui-product-approvals/static-1.28602",
  "ui-tool-access": "/ui-tool-access/static-1.10260",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9409",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5878",
  "usage-tracker-public": "/usage-tracker-public/static-1.7272",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3668",
  "persist-promise": "/persist-promise/static-1.3812",
  "reference-resolvers": "/reference-resolvers/static-1.8287",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4036",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.449",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3130",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3094",
  "atom": "/atom/static-1.5187",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6085",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1655",
  "crm-component-utils": "/crm-component-utils/static-1.39377",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6000",
  "customer-data-properties": "/customer-data-properties/static-1.51967",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7004",
  "property-value-citations": "/property-value-citations/static-1.2581",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8210",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9179",
  "navigation-messaging": "/navigation-messaging/static-1.7615",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10239",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4927",
  "content-icons-ui": "/content-icons-ui/static-1.2257",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9938",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7360",
  "crm-message-bus": "/crm-message-bus/static-1.43277",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22624",
  "events-data-lib": "/events-data-lib/static-1.343",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4833",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4086",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6909",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1094",
  "onboarding-tours": "/onboarding-tours/static-1.16812",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14004",
  "academy-common-lib": "/academy-common-lib/static-1.14192",
  "content-assistance-lib": "/content-assistance-lib/static-1.7930",
  "dashboard-lib": "/dashboard-lib/static-1.81970",
  "file-manager-components": "/file-manager-components/static-1.23934",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18726",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18560",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18552",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20025",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8817",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4871",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11176",
  "user-context": "/user-context/static-1.5222",
  "growth-payments-core": "/growth-payments-core/static-1.25711",
  "reporting-plugins": "/reporting-plugins/static-1.10502",
  "reporting-reports": "/reporting-reports/static-1.67705",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.837",
  "nest": "/nest/static-1.344",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10739",
  "framework-listing-lib": "/framework-listing-lib/static-2.29010",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30976",
  "apps-service-types": "/apps-service-types/static-1.3911",
  "oauth-service-types": "/oauth-service-types/static-1.4366",
  "react-dnd-compat": "/react-dnd-compat/static-1.4727",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.497",
  "onboarding-scopes": "/onboarding-scopes/static-1.6573",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5026",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7753",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15063",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3671",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9592",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6088",
  "signup-constants": "/signup-constants/static-1.19112",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8170",
  "card-properties-lib": "/card-properties-lib/static-1.44533",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37402",
  "crm-actions": "/crm-actions/static-1.6452",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43923",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9568",
  "customer-data-tracking": "/customer-data-tracking/static-1.7000",
  "hs-resources": "/hs-resources/static-1.284",
  "pulse": "/pulse/static-1.710",
  "calling-global-api": "/calling-global-api/static-1.64900",
  "calling-internal-common": "/calling-internal-common/static-1.31422",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66282",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58576",
  "commerce-products-lib": "/commerce-products-lib/static-1.9966",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3877",
  "crm-links": "/crm-links/static-1.6420",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4219",
  "external-options-client-types": "/external-options-client-types/static-1.4209",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4298",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.746",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3772",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49134",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4048",
  "smart-property-lib": "/smart-property-lib/static-1.7789",
  "tiered-pricing": "/tiered-pricing/static-1.1509",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11101",
  "zustand": "/zustand/static-1.74",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.123",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1161",
  "growth-data-modal": "/growth-data-modal/static-1.5606",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3177",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2242",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.878",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7731",
  "academy-service-client": "/academy-service-client/static-1.3795",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39433",
  "FileManagerLib": "/FileManagerLib/static-1.39574",
  "SafeStorage": "/SafeStorage/static-1.4511",
  "video-embed": "/video-embed/static-1.36133",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28874",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11641",
  "video-data-lib": "/video-data-lib/static-1.35299",
  "content-media-capture": "/content-media-capture/static-1.4855",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23821",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9998",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24622",
  "viral-links-lib": "/viral-links-lib/static-1.7181",
  "data-token-picker": "/data-token-picker/static-1.16604",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.336",
  "timezone-utils": "/timezone-utils/static-2.5355",
  "seat-types-lib": "/seat-types-lib/static-1.270",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17844",
  "ui-addon-opt": "/ui-addon-opt/static-4.8473",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9432",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25668",
  "framework-data-table": "/framework-data-table/static-2.12173",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6977",
  "nudge-client-utils": "/nudge-client-utils/static-1.2815",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1223",
  "switchboard-lib": "/switchboard-lib/static-1.335",
  "app-users-service-client": "/app-users-service-client/static-1.5720",
  "app-users-service-types": "/app-users-service-types/static-1.5128",
  "mini-checkout-client": "/mini-checkout-client/static-1.27087",
  "onboarding-utils": "/onboarding-utils/static-1.5471",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2061",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28859",
  "edison-service-client-types": "/edison-service-client-types/static-1.501",
  "crm_data": "/crm_data/static-4.92323",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46326",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16907",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4371",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1240",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19454",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18809",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10676",
  "crm-fe-perf": "/crm-fe-perf/static-1.23015",
  "event-emitter": "/event-emitter/static-1.1061",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.213",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31429",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11148",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6655",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1431",
  "commerce-permissions": "/commerce-permissions/static-1.888",
  "products-iframe-lib": "/products-iframe-lib/static-1.8242",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10623",
  "data-agent-kit": "/data-agent-kit/static-1.379",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10324",
  "policy-lib": "/policy-lib/static-1.6893",
  "react-tinymce": "/react-tinymce/static-1.55539",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10387",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54665",
  "tinymce-plugins": "/tinymce-plugins/static-1.57779",
  "tinymce-themes": "/tinymce-themes/static-1.56635",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2153",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2270",
  "user-context-client": "/user-context-client/static-1.4692",
  "audio-components": "/audio-components/static-1.6088",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37085",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4648",
  "video-components": "/video-components/static-1.13643",
  "outpost": "/outpost/static-1.4282",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6691",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12659",
  "content-media-compositions": "/content-media-compositions/static-2.16666",
  "media-bridge-lib": "/media-bridge-lib/static-1.19120",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4536",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6304",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5193",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3705",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21872",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3962",
  "ts-utils-lib": "/ts-utils-lib/static-1.285",
  "crm-export-dialog": "/crm-export-dialog/static-1.6397",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6553",
  "crm-view-components": "/crm-view-components/static-1.616",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7442",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2572",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2891",
  "whisper-core-api": "/whisper-core-api/static-1.6872",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15107",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5798",
  "settings-content-modals": "/settings-content-modals/static-1.46400",
  "crm_universal": "/crm_universal/static-1.22206",
  "customer-data-email": "/customer-data-email/static-1.18234",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37499",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39825",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12606",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55094",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21774",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18249",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72382",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5456",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9836",
  "utility-belt": "/utility-belt/static-1.2644",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23244",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7707",
  "customer-data-rte": "/customer-data-rte/static-1.33292",
  "cv-backend-services": "/cv-backend-services/static-1.1558",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5947",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5218",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38472",
  "trials-service-types": "/trials-service-types/static-1.3994",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36208",
  "sales-views-client-types": "/sales-views-client-types/static-1.4369",
  "hub-http-contrib": "/hub-http-contrib/static-1.3156",
  "interframe": "/interframe/static-3.4872",
  "tinymce-data": "/tinymce-data/static-1.40750",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5321",
  "layout-dnd-components": "/layout-dnd-components/static-1.12662",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11637",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15687",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9136",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7717",
  "social-insights-client-types": "/social-insights-client-types/static-1.22327",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4282",
  "checkout-sdk": "/checkout-sdk/static-3.23930",
  "company-details-components": "/company-details-components/static-1.6310",
  "payment-method-components": "/payment-method-components/static-1.6983",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14691",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3577",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3634",
  "access-control-lib": "/access-control-lib/static-1.10548",
  "EmailComponents": "/EmailComponents/static-1.55080",
  "EmailData": "/EmailData/static-1.53757",
  "redux-less": "/redux-less/static-2.9595",
  "sequences-lib": "/sequences-lib/static-1.8244",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10462",
  "products-ui-components": "/products-ui-components/static-1.40484",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7247",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55110",
  "commerce-products-api": "/commerce-products-api/static-1.2461",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57168",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103060",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81103",
  "stripe-connect-js": "/stripe-connect-js/static-1.71",
  "draft-content-plugins": "/draft-content-plugins/static-1.28559",
  "ContentData": "/ContentData/static-1.68762",
  "layout-data-lib": "/layout-data-lib/static-1.9962",
  "checkout-service-types": "/checkout-service-types/static-1.3879",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.809",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4049",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4102",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.669",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18717",
  "pricing-pages-api": "/pricing-pages-api/static-1.14556",
  "ContentComponents": "/ContentComponents/static-2.71643",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10420",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1983",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46589",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1451",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19211",
  "automation-ui-types": "/automation-ui-types/static-1.20129",
  "messaging-types-lib": "/messaging-types-lib/static-1.46326",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4615",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8101",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.648",
  "price-books-api": "/price-books-api/static-1.1233",
  "price-books-components": "/price-books-components/static-1.1291",
  "property-description-translator": "/property-description-translator/static-1.3952",
  "ramp-editor": "/ramp-editor/static-1.443",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3693",
  "totals-ui-components": "/totals-ui-components/static-1.23904",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9403",
  "advanced-menus-core": "/advanced-menus-core/static-1.15312",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12225",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34343",
  "segments-query-core": "/segments-query-core/static-1.1532",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6045",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7451",
  "data-token-views": "/data-token-views/static-1.16585",
  "forms-utils-lib": "/forms-utils-lib/static-1.12792",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13262",
  "simple-menus-core": "/simple-menus-core/static-1.15311",
  "simple-menus-lib": "/simple-menus-lib/static-1.16828",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6981",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7624",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
  "ContentEditorUI": "/ContentEditorUI/static-2.77423",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4035",
  "web-interactives-components": "/web-interactives-components/static-1.13957",
  "web-interactives-data": "/web-interactives-data/static-1.13958",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.900",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1070",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1088",
  "line-items-api": "/line-items-api/static-1.857",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3899",
  "FireAlarmUi": "/FireAlarmUi/static-1.4589",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4250",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22065",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21528",
  "data-studio-ubb": "/data-studio-ubb/static-1.3048",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27276",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58175",
  "content-management-data-lib": "/content-management-data-lib/static-1.5600",
  "copilot-plugins": "/copilot-plugins/static-1.11400",
  "cta-picker": "/cta-picker/static-1.36696",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3403",
  "editor-components": "/editor-components/static-1.13391",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8557",
  "error-messaging-js": "/error-messaging-js/static-1.5305",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86118",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10759",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1857",
  "smart-content-core": "/smart-content-core/static-1.42747",
  "smart-content-lib": "/smart-content-lib/static-1.43400",
  "social-composer-lib": "/social-composer-lib/static-1.59561",
  "structured-content-lib": "/structured-content-lib/static-1.25491",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53550",
  "tinymce-copilot": "/tinymce-copilot/static-1.16733",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8051",
  "automation-ui-routing": "/automation-ui-routing/static-1.21486",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5727",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42440",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3303",
  "reporting-enablement": "/reporting-enablement/static-1.23312",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21822",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2972",
  "forms-ai-lib": "/forms-ai-lib/static-1.4493",
  "codemirror-dlb": "/codemirror-dlb/static-1.58982",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6547",
  "report-customization-components": "/report-customization-components/static-1.13478",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13326",
  "reporting-filters": "/reporting-filters/static-1.601",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2076"
}
};
